<template>
  <div class="app-date-picker-shortcuts">
    <div class="app-date-picker-shortcuts__zeile app-date-picker-shortcuts__zeile--monate">
      <button
        v-for="(month, index) in months"
        :key="'shortcut-month-' + month"
        type="button"
        class="app-date-picker-shortcuts__segment"
        @click="selectMonth(index)"
      >
        {{ month }}
      </button>
    </div>
    <div class="app-date-picker-shortcuts__zeile app-date-picker-shortcuts__zeile--quartale">
      <button
        v-for="quarter in quarters"
        :key="'shortcut-quarter-' + quarter"
        type="button"
        class="app-date-picker-shortcuts__segment"
        @click="selectQuarter(quarter)"
      >
        {{ quarter }}
      </button>
    </div>
    <div class="app-date-picker-shortcuts__zeile app-date-picker-shortcuts__zeile--jahre">
      <button
        v-for="year in years"
        :key="'shortcut-year-' + year"
        type="button"
        class="app-date-picker-shortcuts__segment"
        @click="selectYear(year)"
      >
        {{ year }}
      </button>
    </div>
  </div>
</template>

<script>
import { add, parse, format, sub } from 'date-fns';
const moment = require('moment');

export default {
  name: 'AppDatePickerShortcuts',
  props: {
    // Jahr, auf das die Monatsbuttons wirken, üblicherweise der im Kalender angezeigte Zeitraum
    jahr: { type: Number, default: () => new Date().getFullYear() },
  },
  computed: {
    months() {
      return Array.apply(0, Array(12)).map(function (_, i) {
        return moment().month(i).format('MMM');
      });
    },
    // 12 Quartale ab dem aktuellen Jahr im Format "Q1/26"
    quarters() {
      const currentYear = new Date().getFullYear();
      const firstOfCurrentYear = parse('01/01/' + currentYear, 'MM/dd/yyyy', new Date());

      return Array.apply(0, Array(12)).map(function (_, i) {
        return format(add(firstOfCurrentYear, { months: i * 3 }), 'QQQ/yy');
      });
    },
    // Jahre: aktuelles Jahr ± 3
    years() {
      const currentYear = new Date().getFullYear();
      const yearRange = 3;
      return Array.from({ length: yearRange * 2 + 1 }, (_, i) => currentYear - yearRange + i);
    },
  },
  methods: {
    // Der Monat bezieht sich auf das aktuell angezeigte Jahr
    selectMonth(index) {
      const firstDay = new Date(this.jahr, index, 1);
      const lastDay = new Date(this.jahr, index + 1, 0);
      this.$emit('select', [firstDay, lastDay]);
    },
    // Das Quartals-Label hat das Format "Q1/26"
    selectQuarter(quarterLabel) {
      const quarter = quarterLabel.substring(1, 2);
      const year = quarterLabel.substring(3, 5);
      const firstDay = new Date(`20${year}`, (quarter - 1) * 3, 1);
      const lastDay = sub(new Date(`20${year}`, 3 + (quarter - 1) * 3, 1), { days: 1 });
      this.$emit('select', [firstDay, lastDay]);
    },
    selectYear(year) {
      const firstDay = new Date(year, 0, 1);
      const lastDay = new Date(year, 11, 31);
      this.$emit('select', [firstDay, lastDay]);
    },
  },
};
</script>

<style scoped>
/* die drei Datumsraster sitzen gemeinsam auf einer eingelassenen Fläche */
.app-date-picker-shortcuts {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: 2px;
  padding: 4px;
  background: var(--surface-sunken);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
}

.app-date-picker-shortcuts__zeile {
  display: grid;
  gap: 2px;
}

.app-date-picker-shortcuts__zeile--monate,
.app-date-picker-shortcuts__zeile--quartale {
  grid-template-columns: repeat(12, 1fr);
}

.app-date-picker-shortcuts__zeile--jahre {
  grid-template-columns: repeat(7, 1fr);
}

.app-date-picker-shortcuts__segment {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  padding: 0 2px;
  background: transparent;
  border: none;
  border-radius: var(--radius-sm);
  color: var(--text-body);
  font-size: 12px;
  white-space: nowrap;
  cursor: pointer;
}

.app-date-picker-shortcuts__segment:hover {
  background: var(--surface);
  color: var(--text);
}
</style>
